import React, { useState } from "react";

import BaseDatePicker from "components/baseDatePicker";
import Button from "components/button";
import Input from "components/input";
import getRange from "utils/getRange";

import styles from "./datePicker.scss";

const Datepicker = (props) => {
	const {
		name,
		label,
		value,
		touched,
		onBlur,
		onChange,
		errors,
		helpTexts,
		years,
		getMonthName,
		getYear,
		dateFormat,
		disableYearSelection,
		addMonthToHeader,
		addYearToHeader,
		...optionalProps
	} = props;

	const [isYearSelectionVisible, setIsYearSelectionVisible] = useState(false);

	const CustomDateInput = (props) => {
		return (
			<Input
				{...props}
				type="text"
				name={name}
				label={label}
				touched={touched}
				onBlur={onBlur}
				errors={errors}
				helpTexts={helpTexts}
				autoComplete="off"
				readOnly="true"
			>
				{value ? (
					<span className={`material-icons ${styles.icon} ${styles.closeIcon}`} onClick={() => onChange(null)}>
						close
					</span>
				) : (
					<i className={`material-icons  ${styles.icon}`} onClick={props.onClick}>
						date_range
					</i>
				)}
			</Input>
		);
	};

	const getMonthYearSelectionHeader = (date) => {
		let str = "";
		if (addMonthToHeader) {
			str = getMonthName(date);
		}
		if (addYearToHeader) {
			str = str + " " + getYear(date);
		}
		return str;
	};

	const renderCustomHeader = (props) => {
		const { date, changeYear, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled } = props;

		return (
			<div className={styles.monthYearSelection}>
				<div className={styles.month}>
					{getMonthYearSelectionHeader(date)}
					{!disableYearSelection && (
						<div
							className={`${styles.upDownArrow} ${isYearSelectionVisible ? styles.active : ""}`}
							onClick={() => setIsYearSelectionVisible((value) => !value)}
						>
							<span className={`material-icons ${styles.down}`}>keyboard_arrow_down</span>
						</div>
					)}
				</div>
				{isYearSelectionVisible && (
					<div className={styles.years}>
						{years.map((year) => (
							<Button
								key={year}
								displayName={year}
								variant=""
								buttonClass={date.getFullYear() === year ? styles.selected : ""}
								onClick={() => {
									setIsYearSelectionVisible(false);
									changeYear(year);
								}}
							/>
						))}
					</div>
				)}
				<div className={styles.backForwardArrow}>
					<span
						className={`material-icons ${prevMonthButtonDisabled ? styles.disabled : ""}`}
						onClick={decreaseMonth}
						disabled={prevMonthButtonDisabled}
					>
						arrow_back
					</span>
					<span
						className={`material-icons ${nextMonthButtonDisabled ? styles.disabled : ""}`}
						onClick={increaseMonth}
						disabled={nextMonthButtonDisabled}
					>
						arrow_forward
					</span>
				</div>
			</div>
		);
	};

	return (
		<div className={styles.datePicker}>
			<BaseDatePicker
				{...optionalProps}
				renderCustomHeader={renderCustomHeader}
				selectedDate={value}
				onChange={onChange}
				dateFormat={dateFormat}
				onClickOutside={() => setIsYearSelectionVisible(false)}
				customInput={<CustomDateInput />}
			/>
		</div>
	);
};

export default Datepicker;

Datepicker.defaultProps = {
	getMonthName: (date) => date.toLocaleString("default", { month: "long" }),
	getYear: (date) => date.getFullYear(),
	years: getRange(1990, new Date().getFullYear() + 1),
	dateFormat: "dd/MMM/yyyy",
	addMonthToHeader: true,
	addYearToHeader: true,
	placeholderText: "Select Date",
	label: "Select Date",
};
